<div class="permissions-modal__backdrop animated fadeIn">
	<div class="permissions-modal__wrapper">
		<div class="permissions-modal">
			<div class="permissions-modal__header">
				<h3 class="permissions-modal__title">{{ data?.title }}</h3>
			</div>
			<app-show-process *ngIf="isPermissionsLoading; else accountPermissions"></app-show-process>
			<ng-template #accountPermissions>
				<div class="permissions-modal__content">
					<app-admin-modal-permissions [data]="permissions"></app-admin-modal-permissions>
				</div>
			</ng-template>
			<div class="permissions-modal__actions">
				<button class="permissions-modal__close" (click)="closeEvent()">Close</button>
			</div>
		</div>
	</div>
</div>
